//libs
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { CloudArrowUpIcon } from "@heroicons/react/24/outline";
//components
// import Alert from "components/Alert";
import Button from "components/Button";
import Message from "components/Message";
import TenderDocumentsTable from "../GeneralInformation/TenderDocumentsTable";
// import AddendumClarificationsNegotiationsTable from "./AddendumClarificationsNegotiationsTable";
import AddNewTenderDocumentModal from "./AddNewTenderDocumentModal";
import BidItems from "./BidItems";
import FileDropzone from "components/FileDropzone";

export default function TenderProposals({
  tender,
  tenderFeesReceipt,
  setTenderFeesReceipt,
}) {
  const isTender = tender.opportunity_type === 1;
  const [isAddNewTenderModalOpen, setIsAddNewTenderModalOpen] = useState(false);

  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   setValue("tenderFeesReceipt", file);
  // };

  return (
    <div className="pb-16 grid grid-cols-4 rounded-md">
      {/* <div className="col-span-full pt-2">
        <Alert
          message={
            "The information contained within the procurement notices/documents is intended for the sole purpose of suppliers preparing for their bids, and shall be used only for this intended purpose. They shall not be reproduced, distributed, adapted, modified, republished, displayed, broadcasted, hyperlinked, framed or transmitted in any manner or by any means without prior permission, other than for its intended purpose."
          }
        />
      </div> */}
      {/* <div className="col-span-full py-6">
        <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6"></div>
      </div> */}
      {/* <div className="col-span-full py-6">
        <h4 className="font-semibold leading-8 mb-4">
          ADDENDUMS / CLARIFICATIONS / NEGOTIATIONS
        </h4>
        <AddendumClarificationsNegotiationsTable
          items={tender.tender_addendums}
        />
      </div> */}
      <div className="space-y-6 col-span-full">
        {!isTender && (
          <div className="flex items-start gap-4 col-span-full">
            <div className="flex-shrink-0 w-10 h-10 bg-blue-500 text-white rounded-lg flex items-center justify-center font-semibold">
              A
            </div>
            <div className="pb-4 flex-1">
              <div className="mb-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-gray-900">
                  Bid for Items
                  <span className="bg-blue-50 flex items-center gap-2 font-medium border border-blue-300 text-blue-500 text-xs px-2 py-0.5 rounded-full">
                    <div className="rounded-full w-1.5 h-1.5 bg-blue-500" />
                    {tender.tender_items.length ?? 0} Items
                  </span>
                </div>
                <h3 className="font-medium text-gray-500 text-xs">
                  Tender Items that you need to respond to
                </h3>
              </div>
              <BidItems items={tender.tender_items} />
            </div>
          </div>
        )}
        <div className="flex items-start gap-4 col-span-full">
          <div className="flex-shrink-0 w-10 h-10 bg-blue-500 text-white rounded-lg flex items-center justify-center font-semibold">
            {isTender ? "A" : "B"}
          </div>
          <div className="pb-4 flex-1">
            <div className="mb-4">
              <div className="text-sm font-semibold text-gray-900">
                Documents
              </div>
              <h3 className="font-medium text-gray-500 text-xs">
                Attach documents to complement your response.
              </h3>
            </div>
            <TenderDocumentsTable
              documents={tender.documents}
              actionButton={
                <Button
                  variant="outline"
                  color="slate"
                  onClick={() => setIsAddNewTenderModalOpen(true)}
                  className="h-8 flex items-center gap-2 text-xs text-gray-600 hover:text-gray-900"
                >
                  <CloudArrowUpIcon className="size-5" />
                  Upload Document
                </Button>
              }
            />
          </div>
        </div>
        <div className="flex items-start gap-4 col-span-full">
          <div className="flex-shrink-0 w-10 h-10 bg-blue-500 text-white rounded-lg flex items-center justify-center font-semibold">
            {isTender ? "B" : "C"}
          </div>
          <div className="flex-1">
            <div className="mb-4">
              <div className="text-sm font-semibold text-gray-900">
                Tender Fees
              </div>
              <h3 className="font-medium text-gray-500 text-xs mb-6">
                You need to pay tender fees and submit the payment receipt here
                before submitting
              </h3>
              {/* <div className="flex gap-8">
                <div>
                  <div className="text-sm font-semibold text-gray-900">
                    Tender Fees Receipt *
                  </div>
                  <h3 className="font-medium text-gray-500 text-xs">
                    Update your company logo and then choose where you want it
                    to display.
                  </h3>
                </div>
                <div className="flex-1 ">
                  <div>
                    <label
                      htmlFor="tenderFeesReceipt"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Tender Fees Receipt{" "}
                      <span className="text-red-600">*</span>
                    </label>
                    <div className="mt-0">
                      <input
                        id="tenderFeesReceipt"
                        type="file"
                        disabled={tender?.tender_proposal_status === "proposed"}
                        onChange={handleFileChange}
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                      />
                    </div>
                    {errors.tenderFeesReceipt && (
                      <Message message={errors.tenderFeesReceipt.message} />
                    )}
                  </div>
                </div>
              </div> */}
              <div className="flex gap-8">
                <div className="max-w-xs">
                  <div className="text-sm font-semibold text-gray-900">
                    Tender Fees Receipt *
                  </div>
                  <h3 className="font-medium text-gray-500 text-xs">
                    Update your company logo and then choose where you want it
                    to display.
                  </h3>
                </div>
                <div className="flex-1">
                  <FileDropzone
                    value={tenderFeesReceipt}
                    onChange={(file) => {
                      setValue("tenderFeesReceipt", file);
                      setTenderFeesReceipt(file);
                    }}
                    disabled={tender?.tender_proposal_status === "proposed"}
                    error={errors.tenderFeesReceipt?.message}
                  />
                </div>
              </div>
              <div className="mt-6">
                <label
                  htmlFor="proposalComment"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Comment <span className="text-red-600">*</span>
                </label>
                <div className="mt-2">
                  <textarea
                    rows={3}
                    id="proposalComment"
                    {...register("proposalComment")}
                    type="text"
                    disabled={tender?.tender_proposal_status === "proposed"}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                    onChange={(e) =>
                      setValue("proposalComment", e.target.value)
                    }
                  />
                </div>
                {errors.proposalComment && (
                  <Message message={errors.proposalComment.message} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddNewTenderDocumentModal
        tenderId={tender.id}
        isTender={isTender}
        open={isAddNewTenderModalOpen}
        setOpen={setIsAddNewTenderModalOpen}
      />
    </div>
  );
}
